import React, { useCallback } from 'react';
import {
  Box,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Collapse
} from '@mui/material';

import DebouncedTextField from '../../Utils/debounce';

export default function AccertamentoNutrizione({ parameters, setParameters }) {

  const set = (key, value) =>
    setParameters(prev => ({ ...prev, [key]: value }));

  const setField = useCallback((key, value) => {
    setParameters(prev => ({ ...prev, [key]: value }));
  }, []);

  const toggleRadio = (key, newValue) =>
    set(key, parameters[key] === newValue ? '' : newValue);

  const p = parameters;

  return (
    <Box sx={{ width: '50ch', display: 'grid', gap: 2 }}>

      <Box sx={{ p: 3, mb: 2, border: '1px solid rgba(0,0,0,0.23)', borderRadius: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
        <Box component="h1" sx={{ m: 0, fontSize: '1.8rem', fontWeight: 'bold', color: '#1976d2' }}>
          Accertamento Infermieristico
        </Box>
        <Box component="p" sx={{ m: 0, mt: 1, fontSize: '1rem', color: 'text.secondary' }}>
          Nutrizione
        </Box>
      </Box>

      <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Dieta artificiale</FormLabel>
        <RadioGroup row value={p.dietaArtificiale ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('dietaArtificiale', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('dietaArtificiale', 'false')} />} label="No" />
        </RadioGroup>

        <Collapse in={p.dietaArtificiale === 'true'}>
          <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
            <FormLabel sx={{ minWidth: 200 }}>Tipologia</FormLabel>
            <RadioGroup row value={p.tipoDietaArtificiale ?? ''}>
              <FormControlLabel value="NPT"      control={<Radio onClick={() => set('tipoDietaArtificiale', 'NPT')}      />} label="NPT" />
              <FormControlLabel value="NE"       control={<Radio onClick={() => set('tipoDietaArtificiale', 'NE')}       />} label="NE" />
              <FormControlLabel value="ENTRAMBE" control={<Radio onClick={() => set('tipoDietaArtificiale', 'ENTRAMBE')} />} label="Entrambe" />
            </RadioGroup>
          </FormControl>
        </Collapse>
      </FormControl>

      <Collapse in={p.dietaArtificiale === 'false' || p.dietaArtificiale === '' || p.dietaArtificiale == null}>
        <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          <FormLabel sx={{ minWidth: 200 }}>Dieta speciale</FormLabel>
          <RadioGroup row value={p.dietaSpeciale ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('dietaSpeciale', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('dietaSpeciale', 'false')} />} label="No" />
          </RadioGroup>
          {p.dietaSpeciale === 'true' && (
            <DebouncedTextField size="small" label="Tipo di dieta speciale" sx={{ width: 260 }}
              value={p.dietaSpecialeTipo ?? ''}
              onChange={(val) => setField('dietaSpecialeTipo', val)} />
          )}
        </FormControl>
      </Collapse>

      <Collapse in={p.dietaArtificiale === 'false' || p.dietaArtificiale === '' || p.dietaArtificiale == null}>
        <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          <FormLabel sx={{ minWidth: 200 }}>Appetito</FormLabel>
          <RadioGroup row value={p.appetito ?? ''} onChange={e => set('appetito', e.target.value)}>
            {['Stazionario', 'Aumentato', 'Diminuito'].map(v => (
              <FormControlLabel key={v} value={v} control={<Radio />} label={v} />
            ))}
          </RadioGroup>
        </FormControl>
      </Collapse>

      <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Variazione peso (6 mesi)</FormLabel>
        <RadioGroup row value={p.variazionePeso ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('variazionePeso', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('variazionePeso', 'false')} />} label="No" />
        </RadioGroup>
        <Collapse in={p.variazionePeso === 'true'}>
          <DebouncedTextField size="small" label="Quanto (kg)" sx={{ width: 120 }}
            value={p.pesoQuantita ?? ''}
            onChange={(val) => setField('pesoQuantita', val)} />
        </Collapse>
      </FormControl>

      <Collapse in={p.dietaArtificiale === 'false' || p.dietaArtificiale === '' || p.dietaArtificiale == null}>
        <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          <FormLabel sx={{ minWidth: 200 }}>Protesi mobili</FormLabel>
          <RadioGroup row value={p.protesi ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('protesi', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('protesi', 'false')} />} label="No" />
          </RadioGroup>
          <Collapse in={p.protesi === 'true'}>
            <DebouncedTextField required size="small" label="Tipo di protesi" sx={{ width: 200 }}
              value={p.protesiTipo ?? ''}
              onChange={(val) => setField('protesiTipo', val)} />
          </Collapse>
        </FormControl>
      </Collapse>

      <Collapse in={p.dietaArtificiale === 'false' || p.dietaArtificiale === '' || p.dietaArtificiale == null}>
        <>
          <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
            <FormLabel sx={{ minWidth: 200 }}>Difficoltà masticazione</FormLabel>
            <RadioGroup row value={p.masticazione ?? ''}>
              <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('masticazione', 'true')}  />} label="Sì" />
              <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('masticazione', 'false')} />} label="No" />
            </RadioGroup>
          </FormControl>

          <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
            <FormLabel sx={{ minWidth: 200 }}>Difficoltà deglutizione</FormLabel>
            <RadioGroup row value={p.deglutizione ?? ''}>
              <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('deglutizione', 'true')}  />} label="Sì" />
              <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('deglutizione', 'false')} />} label="No" />
            </RadioGroup>
          </FormControl>
        </>
      </Collapse>

      <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Assenza dentizione</FormLabel>
        <RadioGroup row value={p.assenzaDentizione ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('assenzaDentizione', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('assenzaDentizione', 'false')} />} label="No" />
        </RadioGroup>
        <Collapse in={p.assenzaDentizione === 'true'}>
          <DebouncedTextField size="small" label="Parziale/Completa – Superiore/Inferiore" sx={{ width: 260 }}
            value={p.assenzaDentizioneTipo ?? ''}
            onChange={(val) => setField('assenzaDentizioneTipo', val)} />
        </Collapse>
      </FormControl>

      <Collapse in={p.dietaArtificiale === 'true'}>
        <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
          <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
            <FormLabel sx={{ minWidth: 200 }}>Nutrizione enterale</FormLabel>
            <RadioGroup row value={p.nutrizioneEnterale ?? ''}>
              <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('nutrizioneEnterale', 'true')}  />} label="Sì" />
              <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('nutrizioneEnterale', 'false')} />} label="No" />
            </RadioGroup>
          </FormControl>

          {p.nutrizioneEnterale === 'true' && (
            <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
              <FormLabel sx={{ minWidth: 200 }}>Tipologia</FormLabel>
              <RadioGroup row value={p.tipoEnterale ?? ''}>
                <FormControlLabel value="SNG" control={<Radio onClick={() => set('tipoEnterale', 'SNG')} />} label="SNG" />
                <FormControlLabel value="PEG" control={<Radio onClick={() => set('tipoEnterale', 'PEG')} />} label="PEG" />
              </RadioGroup>

              {p.tipoEnterale === 'SNG' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <DebouncedTextField size="small" label="Tipo" required
                    value={p.enteraleSNGTipo ?? ''} onChange={(val) => setField('enteraleSNGTipo', val)} />
                  <DebouncedTextField size="small" label="CH" required
                    value={p.enteraleSNGCH ?? ''} onChange={(val) => setField('enteraleSNGCH', val)} />
                  <DebouncedTextField size="small" label="Posizionato il" required
                    value={p.enteraleSNGData ?? ''} onChange={(val) => setField('enteraleSNGData', val)} />
                </Box>
              )}

              {p.tipoEnterale === 'PEG' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <DebouncedTextField size="small" label="CH"
                    value={p.enteralePEGCH ?? ''} onChange={(val) => setField('enteralePEGCH', val)} />
                  <DebouncedTextField size="small" label="Posizionato il"
                    value={p.enteralePEGData ?? ''} onChange={(val) => setField('enteralePEGData', val)} />
                </Box>
              )}
            </FormControl>
          )}
        </FormControl>
      </Collapse>

      <Collapse in={p.dietaArtificiale === 'true'}>
        <FormControl sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          <FormLabel sx={{ minWidth: 200 }}>Nutrizione parenterale</FormLabel>
          <RadioGroup row value={p.nutrizioneParenterale ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('nutrizioneParenterale', 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('nutrizioneParenterale', 'false')} />} label="No" />
          </RadioGroup>
          <Collapse in={p.nutrizioneParenterale === 'true'}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <DebouncedTextField size="small" label="Tipo di accesso venoso"
                value={p.parentaleAccessoVenoso ?? ''} onChange={(val) => setField('parentaleAccessoVenoso', val)} />
              <DebouncedTextField size="small" label="Posizione"
                value={p.parenteralePosizione ?? ''} onChange={(val) => setField('parenteralePosizione', val)} />
              <DebouncedTextField size="small" label="Posizionato il"
                value={p.parenteraleData ?? ''} onChange={(val) => setField('parenteraleData', val)} />
            </Box>
          </Collapse>
        </FormControl>
      </Collapse>

    </Box>
  );
}